export const PENALTY = {
  PENALTY: 'penalty',
  HOLD: 'hold',
  PROFIT: 'profit',
}
